import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import "./CancellationPolicy.css";

export default function CancellationPolicy() {
  const whatsappMessage = encodeURIComponent(
    "مرحبًا، أريد طلب تعديل أو إلغاء حجز أو الاستفسار عن سياسة الحجز والإلغاء والتعديل"
  );

  return (
    <main className="cancellation-page" dir="rtl">
      <section className="cancellation-hero">
        <div className="container">
          <h1>سياسة الحجز والإلغاء والتعديل</h1>
          <p>
            نلتزم في التنظيم للسفر والسياحة بتوضيح جميع السياسات المتعلقة
            بالحجز والإلغاء والتعديل بما يحفظ حقوق العملاء ويتوافق مع الأنظمة
            واللوائح المنظمة لخدمات السفر والسياحة.
          </p>
        </div>
      </section>

      <section className="container cancellation-content">
        <div className="policy-card">
          <h2>طبيعة طلب الخدمة</h2>
          <p>
            الموقع الإلكتروني للتنظيم للسفر والسياحة منصة تعريفية لاستقبال
            طلبات الخدمات والاستفسارات. ولا يعتبر إرسال الطلب من خلال الموقع
            تأكيدًا نهائيًا للحجز، حيث يتم تأكيد التفاصيل من خلال فريق المبيعات
            عبر القنوات المعتمدة.
          </p>
        </div>

        <div className="policy-card">
          <h2>آلية تأكيد الحجز</h2>
          <p>
            بعد إرسال طلب الخدمة، يقوم فريق المبيعات بمراجعة البيانات والتواصل
            مع العميل لتأكيد توفر الخدمة والسعر النهائي شامل ضريبة القيمة
            المضافة والرسوم النظامية، ثم يتم استكمال إجراءات الحجز من خلال
            القنوات والأنظمة المعتمدة.
          </p>
        </div>

        <div className="policy-card">
          <h2>سياسة تعديل الحجز</h2>
          <p>
            يمكن للعميل طلب تعديل بيانات الحجز من خلال فورم التواصل الموجود في
            الموقع أو عبر واتساب. ويتم الرد على طلب التعديل خلال مدة أقصاها 24
            ساعة من وقت استلام الطلب.
          </p>
        </div>

        <div className="policy-card">
          <h2>سياسة إلغاء الحجز</h2>
          <p>
            يمكن للعميل طلب إلغاء الحجز من خلال القنوات الرسمية الموضحة في
            الموقع. وتخضع الموافقة على الإلغاء لشروط الخدمة، وموعد الطلب،
            وسياسات مزودي الخدمة إن وجدت.
          </p>
        </div>

        <div className="policy-card">
          <h2>آلية طلب الإلغاء أو التعديل</h2>
          <p>
            يتم تقديم طلب الإلغاء أو التعديل من خلال فورم التواصل في الموقع أو
            عبر واتساب، مع توضيح رقم الحجز أو بيانات الطلب إن وجدت، وبيانات
            العميل للتواصل معه.
          </p>
        </div>

        <div className="policy-card">
          <h2>الرد على الطلبات</h2>
          <p>
            يتم الرد على طلبات الإلغاء أو التعديل خلال مدة أقصاها 24 ساعة من
            وقت استلام الطلب، مع توضيح حالة الطلب للعميل سواء بالقبول أو الرفض
            أو طلب بيانات إضافية.
          </p>
        </div>

        <div className="policy-card">
          <h2>استرداد المبالغ</h2>
          <p>
            في حال قبول طلب الإلغاء، تتم إعادة المبلغ وفق وسيلة الدفع المستخدمة
            وبعد خصم أي رسوم نظامية أو رسوم غير قابلة للاسترداد إن وجدت، ويتم
            توضيح ذلك للعميل قبل إتمام الحجز أو عند تأكيد الطلب.
          </p>
        </div>

        <div className="policy-contact-box">
          <h2>لطلب تعديل أو إلغاء حجز</h2>
          <p>
            يمكنكم التواصل معنا من خلال واتساب مباشرة أو من خلال فورم التواصل
            الموجود في الموقع.
          </p>

          <div className="policy-actions">
            <a
              href={`https://wa.me/966920033239?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="primary-policy-btn"
            >
              <FaWhatsapp />
              تواصل عبر واتساب
            </a>

            <Link to="/contact" className="secondary-policy-btn">
              الذهاب لفورم التواصل
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}